(function () {
  'use strict';

  const API_URL = window.B2B_REGISTER_API;
  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

  const formData = {};
  let selectedTaxDoc = null;

  // Country → Tax ID config
  const COUNTRY_CONFIG = {
    US:    { taxIdLabel: 'EIN or Resale Certificate Number', taxIdPlaceholder: 'EIN (e.g. 12-3456789) or State Resale Certificate Number', taxDocLabel: 'Tax ID Documents', taxDocHint: 'EIN or Resale Certificate',           stateLabel: 'State',            zipLabel: 'ZIP Code' },
    CA:    { taxIdLabel: 'GST/HST Number',  taxIdPlaceholder: '123456789RT0001',  taxDocLabel: 'Tax ID Documents', taxDocHint: 'GST/HST Certificate',                stateLabel: 'Province',         zipLabel: 'Postal Code' },
    GB:    { taxIdLabel: 'VAT Number',      taxIdPlaceholder: 'GB123456789',      taxDocLabel: 'Tax ID Documents', taxDocHint: 'VAT Certificate',                    stateLabel: 'County',           zipLabel: 'Postcode' },
    AU:    { taxIdLabel: 'ABN',             taxIdPlaceholder: '51 824 753 556',   taxDocLabel: 'Tax ID Documents', taxDocHint: 'ABN Certificate',                    stateLabel: 'State',            zipLabel: 'Postcode' },
    DE:    { taxIdLabel: 'VAT ID',          taxIdPlaceholder: 'DE123456789',      taxDocLabel: 'Tax ID Documents', taxDocHint: 'VAT Registration Certificate',       stateLabel: 'State',            zipLabel: 'Postal Code' },
    FR:    { taxIdLabel: 'VAT ID',          taxIdPlaceholder: 'FR12345678901',    taxDocLabel: 'Tax ID Documents', taxDocHint: 'VAT Registration Certificate',       stateLabel: 'Region',           zipLabel: 'Postal Code' },
    IT:    { taxIdLabel: 'VAT ID',          taxIdPlaceholder: 'IT12345678901',    taxDocLabel: 'Tax ID Documents', taxDocHint: 'VAT Registration Certificate',       stateLabel: 'Province',         zipLabel: 'Postal Code' },
    ES:    { taxIdLabel: 'VAT ID',          taxIdPlaceholder: 'ESA12345678',      taxDocLabel: 'Tax ID Documents', taxDocHint: 'VAT Registration Certificate',       stateLabel: 'Province',         zipLabel: 'Postal Code' },
    NL:    { taxIdLabel: 'VAT ID',          taxIdPlaceholder: 'NL123456789B01',   taxDocLabel: 'Tax ID Documents', taxDocHint: 'VAT Registration Certificate',       stateLabel: 'Province',         zipLabel: 'Postal Code' },
    _DEFAULT: { taxIdLabel: 'Tax ID',       taxIdPlaceholder: 'Enter Tax ID',     taxDocLabel: 'Tax ID Documents', taxDocHint: 'Please upload your tax ID document', stateLabel: 'State / Province', zipLabel: 'Postal Code' }
  };

  // EU/Europe countries that use VAT ID
  const EU_COUNTRIES = ['DE','FR','IT','ES','NL','BE','AT','IE','SE','DK','FI','PT','PL','CZ',
    'BG','HR','CY','EE','GR','HU','IS','LV','LI','LT','LU','MT','NO','RO','SK','SI','CH'];

  function getCountryConfig(code) {
    if (COUNTRY_CONFIG[code]) return COUNTRY_CONFIG[code];
    if (EU_COUNTRIES.indexOf(code) !== -1) return Object.assign({}, COUNTRY_CONFIG.DE, { taxIdPlaceholder: code + '123456789' });
    return COUNTRY_CONFIG._DEFAULT;
  }

  // DOM elements
  const steps = document.querySelectorAll('.b2b-register__step');
  const progressSteps = document.querySelectorAll('.b2b-progress-step');
  const submitBtn = document.getElementById('b2b-submit-btn');
  const globalError = document.getElementById('b2b-global-error');

  // Consent checkbox
  const consentCheckbox = document.getElementById('b2b-consent-checkbox');
  if (consentCheckbox && submitBtn) {
    consentCheckbox.addEventListener('change', function () {
      submitBtn.disabled = !consentCheckbox.checked;
    });
  }

  // Customer data
  const customerEmail = (document.getElementById('b2b-customer-email') || {}).value || '';
  const customerFirstName = (document.getElementById('b2b-customer-first-name') || {}).value || '';
  const customerLastName = (document.getElementById('b2b-customer-last-name') || {}).value || '';

  // Tax Document file elements
  const taxDocUpload = document.getElementById('b2b-file-upload');
  const taxDocInput = document.getElementById('b2b-tax-doc');
  const taxDocArea = taxDocUpload ? taxDocUpload.querySelector('.b2b-file-upload__area') : null;
  const taxDocPreview = taxDocUpload ? taxDocUpload.querySelector('.b2b-file-upload__preview') : null;
  const taxDocName = taxDocUpload ? taxDocUpload.querySelector('.b2b-file-upload__filename') : null;
  const taxDocRemove = taxDocUpload ? taxDocUpload.querySelector('.b2b-file-upload__remove') : null;

  // --- Country change handler ---
  function updateCountryFields() {
    const country = document.getElementById('b2b-country').value;
    const cfg = getCountryConfig(country);

    // Tax ID label + placeholder
    const taxIdLabel = document.getElementById('b2b-tax-id-label');
    const taxIdInput = document.getElementById('b2b-tax-id');
    if (taxIdLabel) taxIdLabel.innerHTML = cfg.taxIdLabel + ' <span class="b2b-required">*</span>';
    if (taxIdInput) taxIdInput.placeholder = cfg.taxIdPlaceholder;

    // State label
    const stateLabel = document.getElementById('b2b-state-label');
    const stateInput = document.getElementById('b2b-state');
    if (stateLabel) stateLabel.innerHTML = cfg.stateLabel + ' <span class="b2b-required">*</span>';
    if (stateInput) stateInput.placeholder = cfg.stateLabel;

    // ZIP label
    const zipLabel = document.getElementById('b2b-zip-label');
    const zipInput = document.getElementById('b2b-zip');
    if (zipLabel) zipLabel.innerHTML = cfg.zipLabel + ' <span class="b2b-required">*</span>';
    if (zipInput) zipInput.placeholder = cfg.zipLabel;

    // Tax Document label
    const taxDocLabel = document.getElementById('b2b-tax-doc-label');
    if (taxDocLabel) taxDocLabel.innerHTML = cfg.taxDocLabel + ' <span style="font-weight:400; color:#6b7280; font-size:0.875em;">— ' + cfg.taxDocHint + '</span>';

  }

  const countrySelect = document.getElementById('b2b-country');
  if (countrySelect) {
    countrySelect.addEventListener('change', updateCountryFields);
    updateCountryFields(); // init
  }

  // --- Step navigation ---
  function goToStep(step) {
    steps.forEach(function (el) {
      const s = parseInt(el.dataset.step);
      if (s === step) { el.removeAttribute('hidden'); el.classList.add('b2b-register__step--active'); }
      else { el.setAttribute('hidden', ''); el.classList.remove('b2b-register__step--active'); }
    });
    progressSteps.forEach(function (el) {
      const s = parseInt(el.dataset.step);
      el.classList.toggle('b2b-progress-step--active', s <= step);
      el.classList.toggle('b2b-progress-step--completed', s < step);
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // --- Validation helpers ---
  function showError(field, message) {
    const el = document.querySelector('[data-error="' + field + '"]');
    if (el) { el.textContent = message; el.classList.add('b2b-error-message--visible'); }
    const input = document.querySelector('[name="' + field + '"]');
    if (input) input.classList.add('form-control--error');
  }

  function clearErrors() {
    document.querySelectorAll('.b2b-error-message').forEach(function (el) {
      el.textContent = ''; el.classList.remove('b2b-error-message--visible');
    });
    document.querySelectorAll('.form-control--error').forEach(function (el) {
      el.classList.remove('form-control--error');
    });
    if (globalError) globalError.setAttribute('hidden', '');
  }

  function showGlobalError(message) {
    if (globalError) { globalError.querySelector('p').textContent = message; globalError.removeAttribute('hidden'); }
  }

  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

  // --- Validate form ---
  function validateForm() {
    clearErrors();
    let valid = true;

    const fields = [
      { name: 'country', id: 'b2b-country', label: 'Country' },
      { name: 'business_name', id: 'b2b-business-name', label: 'Business name' },
      { name: 'address', id: 'b2b-address', label: 'Address' },
      { name: 'city', id: 'b2b-city', label: 'City' },
      { name: 'state', id: 'b2b-state', label: 'State / Province' },
      { name: 'zip', id: 'b2b-zip', label: 'Postal Code' },
      { name: 'tax_id', id: 'b2b-tax-id', label: 'Tax ID' },
      { name: 'contact_first_name', id: 'b2b-contact-first-name', label: 'First name' },
      { name: 'contact_last_name', id: 'b2b-contact-last-name', label: 'Last name' },
      { name: 'contact_email', id: 'b2b-contact-email', label: 'Contact email' },
      { name: 'phone', id: 'b2b-phone', label: 'Phone number' }
    ];

    fields.forEach(function (f) {
      const el = document.getElementById(f.id);
      const val = el ? el.value.trim() : '';
      if (!val) { showError(f.name, f.label + ' is required'); valid = false; }
      formData[f.name] = val;
    });

    // Business type
    const businessType = document.getElementById('b2b-business-type').value;
    if (!businessType) { showError('business_type', 'Please select a business type'); valid = false; }
    if (businessType === 'Other') {
      const otherVal = document.getElementById('b2b-business-type-other').value.trim();
      if (!otherVal) { showError('business_type_other', 'Please specify your business type'); valid = false; }
      formData.business_type = otherVal;
    } else {
      formData.business_type = businessType;
    }

    // Job title
    const jobTitle = document.getElementById('b2b-job-title').value;
    if (!jobTitle) { showError('job_title', 'Please select a job title'); valid = false; }
    if (jobTitle === 'Other') {
      const jobTitleOtherVal = document.getElementById('b2b-job-title-other') ? document.getElementById('b2b-job-title-other').value.trim() : '';
      if (!jobTitleOtherVal) { showError('job_title_other', 'Please specify your job title'); valid = false; }
      formData.job_title = jobTitleOtherVal;
    } else {
      formData.job_title = jobTitle;
    }

    // Tax ID type from country
    const country = formData.country;
    const cfg = getCountryConfig(country);
    formData.tax_id_type = cfg.taxIdLabel;
    formData.country_code = country;


    // Build full phone with dial code
    const phoneCodeEl = document.getElementById('b2b-phone-code');
    if (phoneCodeEl && formData.phone) {
      const dialCode = phoneCodeEl.value.replace(/[A-Z]/g, ''); // strip country suffix like +1CA → +1
      const digits = formData.phone.replace(/\D/g, '');
      formData.phone = dialCode + digits;
    }

    // Customer data
    formData.email = customerEmail;
    formData.first_name = customerFirstName;
    formData.last_name = customerLastName;

    if (formData.contact_email && !isValidEmail(formData.contact_email)) {
      showError('contact_email', 'Please enter a valid email');
      valid = false;
    }

    // Validate file sizes and types
    if (selectedTaxDoc) {
      if (ALLOWED_FILE_TYPES.indexOf(selectedTaxDoc.type) === -1) {
        showError('tax_document', 'Only PDF, JPG, and PNG files are allowed');
        valid = false;
      } else if (selectedTaxDoc.size > MAX_FILE_SIZE) {
        showError('tax_document', 'File must be smaller than 10MB');
        valid = false;
      }
    }
    return valid;
  }

  // --- File upload helpers ---
  function setupFileUpload(input, area, preview, nameEl, removeBtn, onSelect, onRemove, errorFieldName) {
    if (!input || !area) return;

    input.addEventListener('change', function (e) {
      const file = e.target.files[0];
      if (!file) return;
      clearErrors();
      if (ALLOWED_FILE_TYPES.indexOf(file.type) === -1) {
        showError(errorFieldName, 'Only PDF, JPG, and PNG files are allowed');
        area.classList.add('b2b-file-upload__area--error');
        input.value = '';
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        showError(errorFieldName, 'File must be smaller than 10MB (' + (file.size / 1024 / 1024).toFixed(1) + 'MB selected)');
        area.classList.add('b2b-file-upload__area--error');
        input.value = '';
        return;
      }
      area.classList.remove('b2b-file-upload__area--error');
      onSelect(file);
      if (nameEl) nameEl.textContent = file.name;
      if (area) area.setAttribute('hidden', '');
      if (preview) preview.removeAttribute('hidden');
    });

    area.addEventListener('click', function () { input.click(); });
    area.addEventListener('dragover', function (e) { e.preventDefault(); area.classList.add('b2b-file-upload__area--dragover'); });
    area.addEventListener('dragleave', function () { area.classList.remove('b2b-file-upload__area--dragover'); });
    area.addEventListener('drop', function (e) {
      e.preventDefault(); area.classList.remove('b2b-file-upload__area--dragover');
      if (e.dataTransfer.files[0]) { input.files = e.dataTransfer.files; input.dispatchEvent(new Event('change')); }
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        onRemove();
        input.value = '';
        if (area) area.removeAttribute('hidden');
        if (preview) preview.setAttribute('hidden', '');
      });
    }
  }

  // Setup tax document upload
  setupFileUpload(taxDocInput, taxDocArea, taxDocPreview, taxDocName, taxDocRemove,
    function (file) { selectedTaxDoc = file; },
    function () { selectedTaxDoc = null; },
    'tax_document'
  );

  // --- Submit ---
  async function submitRegistration() {
    if (!API_URL) { showGlobalError('Registration API is not configured.'); return; }

    submitBtn.classList.add('btn--loading');
    submitBtn.disabled = true;

    try {
      const body = new FormData();
      body.append('data', JSON.stringify(formData));
      if (selectedTaxDoc) body.append('tax_document', selectedTaxDoc);

      const response = await fetch(API_URL, { method: 'POST', mode: 'cors', body: body });
      const result = await response.json();

      if (!response.ok) throw new Error(result.error || 'Registration failed. Please try again.');
      window.scrollTo(0, 0);
      window.location.reload();
    } catch (err) {
      showGlobalError(err.message || 'An unexpected error occurred.');
    } finally {
      submitBtn.classList.remove('btn--loading');
      submitBtn.disabled = false;
    }
  }

  // --- Event listeners ---
  if (submitBtn) {
    submitBtn.addEventListener('click', function () { if (validateForm()) submitRegistration(); });
  }

  // Business type "Other" toggle
  const businessTypeSelect = document.getElementById('b2b-business-type');
  const otherField = document.getElementById('b2b-business-type-other-field');
  if (businessTypeSelect && otherField) {
    businessTypeSelect.addEventListener('change', function () {
      if (businessTypeSelect.value === 'Other') otherField.removeAttribute('hidden');
      else { otherField.setAttribute('hidden', ''); const oi = document.getElementById('b2b-business-type-other'); if (oi) oi.value = ''; }
    });
  }


  // Google Places Address Autocomplete
  (function () {
    const gScript = document.createElement('script');
    gScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + (window.B2B_GOOGLE_MAPS_KEY || '') + '&libraries=places&callback=__b2bInitPlaces';
    gScript.async = true;
    window.__b2bInitPlaces = function () {
      const addressInput = document.getElementById('b2b-address');
      if (!addressInput) return;
      const countrySelect = document.getElementById('b2b-country');
      const countryCode = countrySelect ? countrySelect.value.toLowerCase() : 'us';
      const autocomplete = new google.maps.places.Autocomplete(addressInput, {
        types: ['address'],
        componentRestrictions: { country: countryCode }
      });
      autocomplete.setFields(['address_components', 'formatted_address']);
      autocomplete.addListener('place_changed', function () {
        const place = autocomplete.getPlace();
        if (!place.address_components) return;
        const streetParts = [];
        let city = '', state = '', zip = '', country = '';
        place.address_components.forEach(function (c) {
          const types = c.types;
          if (types.indexOf('street_number') !== -1) streetParts.push(c.long_name);
          if (types.indexOf('route') !== -1) streetParts.push(c.long_name);
          if (types.indexOf('premise') !== -1) streetParts.push(c.long_name);
          if (types.indexOf('subpremise') !== -1) streetParts.push(c.long_name);
          if (types.indexOf('locality') !== -1) city = c.long_name;
          if (!city && types.indexOf('postal_town') !== -1) city = c.long_name;
          if (!city && types.indexOf('sublocality_level_1') !== -1) city = c.long_name;
          if (!city && types.indexOf('sublocality') !== -1) city = c.long_name;
          if (!city && types.indexOf('neighborhood') !== -1) city = c.long_name;
          if (!city && types.indexOf('administrative_area_level_2') !== -1) city = c.long_name;
          if (types.indexOf('administrative_area_level_1') !== -1) state = c.short_name;
          if (types.indexOf('postal_code') !== -1) zip = c.long_name;
          if (types.indexOf('country') !== -1) country = c.long_name;
        });
        let street = streetParts.join(' ');
        // Fallback: extract street from formatted_address if components didn't provide it
        if (!street && place.formatted_address) {
          const parts = place.formatted_address.split(',');
          const exclude = [city, state, zip, country].filter(Boolean);
          street = parts.filter(function (p) {
            const trimmed = p.trim();
            return !exclude.some(function (e) { return trimmed.indexOf(e) !== -1; });
          }).join(', ').trim();
        }
        addressInput.value = street;
        const cityEl = document.getElementById('b2b-city');
        const stateEl = document.getElementById('b2b-state');
        const zipEl = document.getElementById('b2b-zip');
        if (cityEl) cityEl.value = city;
        if (stateEl) stateEl.value = state;
        if (zipEl) zipEl.value = zip;
      });
      // Update country restriction when country changes
      if (countrySelect) {
        countrySelect.addEventListener('change', function () {
          autocomplete.setComponentRestrictions({ country: countrySelect.value.toLowerCase() });
        });
      }
    };
    document.head.appendChild(gScript);
  })();

  // Country → dial code mapping
  const COUNTRY_DIAL_CODES = {
    US: '+1', CA: '+1CA', MX: '+52',
    AT: '+43', BE: '+32', BG: '+359', HR: '+385', CY: '+357', CZ: '+420',
    DK: '+45', EE: '+372', FI: '+358', FR: '+33', DE: '+49', GR: '+30',
    HU: '+36', IS: '+354', IE: '+353', IT: '+39', LV: '+371', LI: '+423',
    LT: '+370', LU: '+352', MT: '+356', NL: '+31', NO: '+47', PL: '+48',
    PT: '+351', RO: '+40', SK: '+421', SI: '+386', ES: '+34', SE: '+46',
    CH: '+41', GB: '+44',
    AU: '+61', CN: '+86', HK: '+852', IN: '+91', ID: '+62', JP: '+81',
    KR: '+82', MY: '+60', NZ: '+64', PH: '+63', SG: '+65', TW: '+886',
    TH: '+66', VN: '+84',
    BH: '+973', IL: '+972', JO: '+962', KW: '+965', OM: '+968', QA: '+974',
    SA: '+966', TR: '+90', AE: '+971',
    AR: '+54', BR: '+55', CL: '+56', CO: '+57', CR: '+506', DO: '+1DO',
    EC: '+593', GT: '+502', PA: '+507', PE: '+51', UY: '+598',
    EG: '+20', GH: '+233', KE: '+254', MA: '+212', NG: '+234', ZA: '+27'
  };

  // Auto-sync phone dial code when country changes
  const phoneCodeSelect = document.getElementById('b2b-phone-code');
  if (countrySelect && phoneCodeSelect) {
    countrySelect.addEventListener('change', function () {
      const dialCode = COUNTRY_DIAL_CODES[countrySelect.value];
      if (dialCode) phoneCodeSelect.value = dialCode;
    });
  }

  // Job title "Other" -> show "Please specify" field
  const jobTitleSelect = document.getElementById('b2b-job-title');
  const jobTitleOtherField = document.getElementById('b2b-job-title-other-field');
  const jobTitleOtherInput = document.getElementById('b2b-job-title-other');
  if (jobTitleSelect && jobTitleOtherField) {
    jobTitleSelect.addEventListener('change', function () {
      if (jobTitleSelect.value === 'Other') {
        jobTitleOtherField.style.display = '';
        if (jobTitleOtherInput) jobTitleOtherInput.required = true;
      } else {
        jobTitleOtherField.style.display = 'none';
        if (jobTitleOtherInput) { jobTitleOtherInput.required = false; jobTitleOtherInput.value = ''; }
      }
    });
  }

  // Phone input: strip non-digits on input
  const phoneInput = document.getElementById('b2b-phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      phoneInput.value = phoneInput.value.replace(/[^\d\s\-()]/g, '');
    });
  }

})();
